// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { WorkflowAnswerOption } from './workflowAnswerOption';

/**
 * Serializer for validating WorkflowResponseAnswer.
 * @see #/components/schemas/WorkflowResponseAnswer - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface WorkflowResponseAnswer {
    /**
     * The identifier of Question-ID.
     *
     */
    question_id: string;
    /**
     * The answer of the Workflow-Item-Answer.
     *
     */
    answer?: WorkflowAnswerOption | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for WorkflowResponseAnswer
 */
export namespace WorkflowResponseAnswer {
    /**
     * WorkflowResponseAnswer Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The identifier of Question-ID.
         * @type string (`dataFormat` is missing)
         */
        questionId: string;
        /**
         * The answer of the Workflow-Item-Answer.
         * @type WorkflowAnswerOption (`dataFormat` is missing)
         */
        @Type(() => WorkflowAnswerOption.Model) answer?: WorkflowAnswerOption.Model | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * WorkflowResponseAnswer DTO
     * Transforms WorkflowResponseAnswer model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend WorkflowResponseAnswer model */
        static toModel(obj: WorkflowResponseAnswer): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend WorkflowResponseAnswer model */
        static toApi(obj: Model): WorkflowResponseAnswer {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as WorkflowResponseAnswer;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
